export const downloadAzureFile = (subFolder: string, fileName: string, type: string = '') => {
  // Enter your storage account name and sas token key
  const account = process.env.REACT_APP_ACCOUNT_NAME || ""; // documentosclientes
  const sas = process.env.REACT_APP_ACCOUNT_SAS || "";

  const shareName = "documentosclientesshared"
  const mainFolder = "documentos_clientes"
  const mainFolderME = "documentos_clientes/me"
  const mainFolderCR = "cp_rechazados"
  // const subFolder = "/202309"  // Este valor debe reemplazarse por resultado de la columna "pathpdfazure" de la tabla "stg_documentosdeventas"
  // const fileName = "CA-0009-00067475.pdf"

  /* Initialize the ShareServiceClient
  @param url - A URL string pointing to Azure Storage file, such as
   *                     "https://myaccount.file.core.windows.net/myshare/mydirectory/file". You can
   *                     append a SAS if using AnonymousCredential, such as
   *                     "https://myaccount.file.core.windows.net/myshare/mydirectory/file?sasString".
   *                     This method accepts an encoded URL or non-encoded URL pointing to a file.
   *                     Encoded URL string will NOT be escaped twice, only special characters in URL path will be escaped.
   *                     However, if a file or directory name includes %, file or directory name must be encoded in the URL.
   * */
  
  const timestamp = Math.floor(Date.now() / 1000);
  const url = `https://${account}.file.core.windows.net/${shareName}/${type === 'ME' ? mainFolderME : type === 'CR' ? mainFolderCR : mainFolder}${subFolder}/${fileName}?${sas}&xyz=${timestamp}`
  return url
}